import { render, staticRenderFns } from "./AuthPage.vue?vue&type=template&id=1f6ad835&scoped=true&"
var script = {}
import style0 from "./AuthPage.vue?vue&type=style&index=0&id=1f6ad835&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6ad835",
  null
  
)

export default component.exports